import React from 'react';
// import flexible from '../../utils/flexible';
import './index.less';
import hic_mobile_pic2 from './img/20191114.png';

class Banner20191114 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '充电安全须知';
    return (
        <div id="banner">
            <img src={hic_mobile_pic2} />
        </div>
    );
  }
}

export default Banner20191114;



// WEBPACK FOOTER //
// ./src/staticPage/banner/20191114/index.js